@if (isVisible()) {
  <div class="spinner-overlay">
    <div class="spinner-container">
      <div class="spinner">
        <div class="spinner-circle"></div>
      </div>
    </div>
  </div>
}
